<script>
  import * as d3 from "d3";
  import Wrapper from "./Wrapper.svelte";

  let promise = loadGeo();

  // Needs verification
  // For example, Cobb county zip codes seem to be missing
  let atl_zips = [
    30002, 30004, 30005, 30008, 30011, 30017, 30019, 30021, 30022, 30024, 30030,
    30032, 30033, 30034, 30035, 30038, 30039, 30043, 30044, 30045, 30047, 30052,
    30058, 30060, 30062, 30064, 30066, 30067, 30068, 30071, 30072, 30075, 30076,
    30078, 30079, 30083, 30084, 30087, 30088, 30092, 30093, 30096, 30097, 30101,
    30106, 30126, 30127, 30144, 30152, 30168, 30213, 30215, 30228, 30236, 30238,
    30260, 30268, 30273, 30274, 30281, 30288, 30291, 30294, 30296, 30297, 30303,
    30305, 30306, 30307, 30308, 30309, 30310, 30311, 30312, 30313, 30314, 30315,
    30316, 30317, 30318, 30319, 30324, 30326, 30327, 30328, 30329, 30331, 30336,
    30337, 30338, 30339, 30340, 30341, 30342, 30344, 30345, 30346, 30349, 30350,
    30354, 30360, 30363, 30517, 30518, 30519,
  ];
  // console.log(atl_zips.length)

  let atl_zips_set = new Set(atl_zips);

  let lower_bound = 10;

  // let rand = -1;
  // function getRand() {
  // 	fetch("./rand")
  // 		.then(d => d.text())
  // 		.then(d => (rand = d));
  // }

  async function loadGeo() {
    const specs = await Promise.all([
      // all zip regions in georgia
      d3.json("ga_zips.json"),

      // cleaned data
      d3.json("cleaned_data.json"),

      //starwood data
      d3.json("starwood.json"),

      // relevant counties
      d3.json("ga_relevant_counties.geojson"),

      // airtables
      d3.json("airtable_clayton_processed.json"),
      d3.json("airtable_cobb_processed.json"),
      d3.json("airtable_dekalb_processed.json"),
      d3.json("airtable_fulton_processed.json"),
      d3.json("airtable_gwinnett_processed.json"),

      // fulton 2019
      d3.json("FultonDekalbFilings2019.json")
    ]);

    let evictions = specs[1].map((d) => {
      d.zip = parseInt(d.zip);
      return d;
    });
    evictions = evictions.filter(
      (d) => d.AddTotCount >= lower_bound && !d.filingdate.startsWith("2017")
    );

    let atl_zips_geojson = { type: "FeatureCollection", features: [] };

    // filter zip regions to atl
    for (let i of specs[0]["features"]) {
      if (atl_zips_set.has(parseInt(i["properties"]["ZCTA5CE10"]))) {
        atl_zips_geojson["features"].push(i);
      }
    }

    let all_airtable = [].concat.apply([], [specs[4], specs[5], specs[6], specs[7], specs[8]]);

    return [atl_zips_geojson, evictions, specs[2], specs[3], all_airtable, specs[9]];
  }
</script>

<div>
  {#await promise}
    <div />
  {:then specs}
    <Wrapper
      {atl_zips}
      state_zip_geojson={specs[0]}
      data={specs[1]}
      starwoodData={specs[2]}
      countiesVector={specs[3]}
      airtable_original={specs[4]}
      fulton_2019 ={specs[5]}
    />
  {/await}
</div>

<style>
</style>
